import BedBath from "./media/BedBath.png";
import Hotel from "./media/Hotel.png";
import Wine from "./media/Clothify.png";
import Spotify from "./media/Crocs.png"

export const details = {
  firstname: "Md Sajid",
  lastname: "Ansari",
  navList: [
    {
      val1: "Home",
      val2: "nav-link home",
    },
    {
      val1: "About",
      val2: "nav-link about",
    },
    {
      val1: "Skills",
      val2: "nav-link skills",
    },
    {
      val1: "Work",
      val2: "nav-link projects",
    },
    {
      val1: "Contact",
      val2: "nav-link contact",
    },
  ],
  scrollPosition: [0, 545, 1070, 1730, 3400],
  className: [
    "introDiv",
    "about section",
    "skillContainer",
    "workDiv",
    "contactDiv",
  ],
  linkedInLink: "https://www.linkedin.com/in/sajid-ansari0/",
  githubLink: "https://github.com/Sajid788",
  instagram: "7061541556",
  mailLink: "mailto:mdsajidalam8340@gmail.com",
  techStack: [
    {
      name: "HTML",
      img: "https://img.icons8.com/color/512/html-5--v1.png",
    },
    {
      name: "CSS",
      img: "https://img.icons8.com/fluency/512/css3.png",
    },
    {
      name: "JavaScript",
      img: "https://img.icons8.com/color/512/javascript.png",
    },
    {
      name: "TypeScript",
      img: "https://www.szymonwojaczek.pl/img/Typescript_logo_2020.fba71f93.png",
    },
    {
      name: "Java",
      img: "https://img.icons8.com/ios-filled/512/java-coffee-cup-logo.png",
    },
    {
      name: "React.js",
      img: "https://img.icons8.com/office/512/react.png",
    },
    {
      name: "Next.js",
      img: "https://phiilu.com/images/icons/next-js-logo.png",
    },
    // {
    //   name: "Material UI",
    //   img: "https://img.icons8.com/color/512/material-ui.png",
    // },
    {
      name: "Chakra UI",
      img: "https://img.icons8.com/color/512/chakra-ui.png",
    },
    {
      name: "Node JS",
      img: "https://img.icons8.com/fluency/512/node-js.png",
    },

    {
      name: "Firebase",
      img: "https://www.gsriram.dev/static/a1a4f6968d81ce96a4391a38eba1c568/12f3f/firebase.png",
    },
    // {
    //   name: "BootStrap",
    //   img: "https://img.icons8.com/color/512/bootstrap.png",
    // },
    {
      name: "Github",
      img: "https://img.icons8.com/glyph-neue/512/github.png",
    },
    {
      name: "Express JS",
      img: "https://img.icons8.com/ios/512/express-js.png",
    },
    {
      name: "Mongo DB",
      img: "https://img.icons8.com/color/512/mongodb.png",
    },
  ],
  projects: [
    {
      name: "Bed Bath Beyond",
      github: "https://github.com/Sajid788/Bed-Bath-Beyond",
      live: "https://6509b685de9fe80cfc50d9a3--velvety-hotteok-be9bd4.netlify.app/",
      type: "Colaborative",
      tech: ["HTML", "CSS", "JavaScript"],
      img: BedBath,
      description:
        "Bed Bath & Beyond is a popular retail chain in the United States that specializes in home goods and furnishings. The Bed Bath & Beyond website serves as an online platform where customers can brows…",
    },

    {
      name: "Gardon Resort",
      github: "https://github.com/swatii23/glorious-calendar-2511",
      live: "https://653652c73f8e7f008122786e--elegant-pudding-10faed.netlify.app/",
      type: "Colaborative",
      tech: ["HTML", "CSS", "JavaScript", "Chakra UI"],
      img: Hotel,
      description:
        "Our hotel website is a showcase of sophistication and convenience. Its intuitive interface guides visitors through a visual journey of our exquisite accommodations, tempting them with breathtaking…",
    },

    {
      name: "Clothify",
      github: "https://github.com/Sajid788/Clothify",
      live: "https://clothisa.netlify.app/",
      type: "Collaborative",
      tech: ["React","Chakra UI","Node JS", "Express JS","Mongo DB" ],
      img: Wine,
      description:
      "Clothify is top-quality branded clothing at unbeatable prices. Our curated collection ensures you'll find something stylish for every occasion. Shop with ease and enjoy significant savings at Clothify."
    },
    {
      name: "Crocs",
      github: "https://github.com/Sajid788/Crocs-land",
      live: "https://corc.netlify.app",
      type: "Solo",
      tech: ["React","Chakra UI","CSS","JavaScript"],
      img: Spotify,
      description: "Crocsland is a replication of Crocs, a renowned footwear brand recognized for its distinct foam clogs crafted from Croslite material. The brand originated in 2002 and has since broadened its range to encompass a variety of footwear styles, including shoes, sandals, boots, and others.",
    },
  ],
};
